import React from 'react';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';

const LoaderPopup = ({ loader }) => {
  if (!loader) return null;
  return (
    <LoaderPopupWrapper>
      <Loader type="Ball-Triangle" color="#3a3a3a" height="40" width="40" />
      <LoadingText>Загрузка...</LoadingText>
    </LoaderPopupWrapper>
  );
};

const mapStateToProps = (state) => {
  const { loader } = state.loader;
  return {
    loader,
  };
};

export default connect(mapStateToProps)(LoaderPopup);

const LoaderPopupWrapper = styled.div`
  width: 200px;
  height: 70px;
  background-color: #000000;
  color: #ffffff;
  position: fixed;
  bottom: 20px;
  left: calc(50% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: #999999;
  font-size: 20px;
  font-weight: bold;
  opacity: 0.9;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.27);
`;

const LoadingText = styled.div`
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/LoaderPopup.jsx